<div style="display: flex;flex-direction: row-reverse;">
    
    <div class="rfq-create-form full-width-container1">
        <div class="rfq-create-form-title">
             <div style="display: flex;flex-direction:row;justify-content: space-between;align-items: center;">
                <div id="createquotation" style="flex:1">
                    View Purchase Order
                </div>
                <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="close(true)">Close<mat-icon>navigate_next</mat-icon></button>
             </div>
             <!-- <div style="float: right; margin-left: 16px;"> -->
            <!-- <div style="display: flex;flex-direction:row;justify-content:flex-end;margin-top:10px;margin-bottom:5px">
                <button mat-button color="primary"
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="close(true)">Close<mat-icon>navigate_next</mat-icon></button>
            </div> -->
        </div>
    
        <div class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4" style="width: 100%;">
            <mat-card class="p-0" style="margin: 0 0.5rem">
                <mat-card-content class="ship-fscoll hgt ship-pr-sec">
                    <nav mat-tab-nav-bar class="tagGroup">
                        <a mat-tab-link *ngFor="let tabItem of tabs; let idx = index"
                            [class.active-link]="currentTab === tabItem.route" class="teb_icon"
                            (click)="selectMatTabLink(tabItem)">
                            <span id="navstepstext">{{tabItem.label}}</span>
                        </a>
                    </nav>
    
    
                    <div class="mat-tab-body-content pos-relative">
                        <div>
                            
                            <form [formGroup]="firstFormGroup">
                            <div>

                                <!-- Purchase Order Details -->
                                <div class="header-form">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form1')">
                                    Purchase Order Details
                                    <mat-icon>{{ isForm1Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm1Expand" class="three-column-flex">

                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Number</mat-label>
                                        <input matInput formControlName="purchaseOrderRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Purchase Order Date</mat-label>
                                        <input matInput [matDatepicker]="poDate" formControlName="purchaseOrderDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="poDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #poDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Ref Number</mat-label>
                                        <input matInput formControlName="rfqRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>RFQ Date</mat-label>
                                        <input matInput [matDatepicker]="rfqDate" formControlName="rfqDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="rfqDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #rfqDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quote Ref Number</mat-label>
                                        <input matInput formControlName="quoteRefNumber" readonly>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Quotation Date</mat-label>
                                        <input matInput [matDatepicker]="quotationDate" formControlName="quotationDate" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="quotationDate" [disabled]="true"></mat-datepicker-toggle>
                                        <mat-datepicker #quotationDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>

                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Expected Delivery Date</mat-label>
                                        <input matInput [matDatepicker]="expectedDeliveryDate" formControlName="expectedDeliveryDate">
                                        <mat-datepicker-toggle matSuffix [for]="expectedDeliveryDate"></mat-datepicker-toggle>
                                        <mat-datepicker #expectedDeliveryDate></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Company Details -->
                                <div class="header-form">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form2')">
                                    Buyer Company Details
                                    <mat-icon>{{ isForm2Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm2Expand" class="three-column-flex">
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Buyer Name</mat-label>
                                        <input matInput formControlName="buyerName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Buyer Details -->
                                <div class="header-form">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form3')">
                                    Buyer Details
                                    <mat-icon>{{ isForm3Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm3Expand" class="three-column-flex">
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Contact Person (Job Title)</mat-label>
                                        <input matInput formControlName="buyerContactPerson" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="buyerContactEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="buyerContactPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="buyerContactFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Address</mat-label>
                                        <input matInput formControlName="buyerContactAddress" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Supplier Details -->
                                <div class="header-form">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form4')">
                                    Supplier Details
                                    <mat-icon>{{ isForm4Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm4Expand" class="three-column-flex">
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Supplier Contact Name</mat-label>
                                        <input matInput formControlName="supplierContactName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Email Id</mat-label>
                                        <input matInput formControlName="supplierEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Phone</mat-label>
                                        <input matInput formControlName="supplierPhone" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Fax</mat-label>
                                        <input matInput formControlName="supplierFax" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Company Email</mat-label>
                                        <input matInput formControlName="supplierCompanyEmail" readonly>
                                    </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Vessel Details -->
                                <div class="header-form">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form5')">
                                    Vessel Details
                                    <mat-icon>{{ isForm5Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm5Expand" class="three-column-flex">
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Name</mat-label>
                                        <input matInput formControlName="vesselName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel IMO Number</mat-label>
                                        <input matInput formControlName="vesselIMONumber" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel Type</mat-label>
                                        <input matInput formControlName="vesselType" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Class</mat-label>
                                        <input matInput formControlName="vesselClass" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Hull Number</mat-label>
                                            <input matInput placeholder="Enter Hull Number" formControlName="hullNumber" readonly>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Yard Name</mat-label>
                                            <input matInput placeholder="Enter Yard Name" formControlName="yardName" readonly>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Year Built</mat-label>
                                            <input matInput placeholder="Enter Year Built" formControlName="yearBuilt" readonly>
                                        </mat-form-field>
                                    </div>
                                </div>
                                </div>

                                <!-- Port Details -->
                                <div class="header-form">
                                <span
                                    style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                                    (click)="toggleVisibility('form6')">
                                    Port Details
                                    <mat-icon>{{ isForm6Expand ? 'minimize' : 'add' }}</mat-icon>
                                </span>

                                <div *ngIf="isForm6Expand" class="three-column-flex">
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Name</mat-label>
                                        <input matInput formControlName="portName" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Port Code</mat-label>
                                        <input matInput formControlName="portCode" readonly>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETA</mat-label>
                                        <input matInput [matDatepicker]="vesselETA" formControlName="vesselETA">
                                        <mat-datepicker-toggle matSuffix [for]="vesselETA"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETA></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                    <mat-form-field class="full-width" color="accent">
                                        <mat-label>Vessel ETD</mat-label>
                                        <input matInput [matDatepicker]="vesselETD" formControlName="vesselETD">
                                        <mat-datepicker-toggle matSuffix [for]="vesselETD"></mat-datepicker-toggle>
                                        <mat-datepicker #vesselETD></mat-datepicker>
                                    </mat-form-field>
                                    </div>
                                    <div class="form-item-row">
                                        <mat-form-field class="full-width" color="accent">
                                            <mat-label>Vessel ETB</mat-label>
                                            <input matInput name="vesselEtb" formControlName="vesselETB"
                                                [matDatepicker]="vesselEtbDatepicker" readonly/>
                                            
                                            <mat-datepicker-toggle matSuffix [for]="vesselEtbDatepicker" [disabled]="true"></mat-datepicker-toggle>
                                        </mat-form-field>
                                        <mat-datepicker #vesselEtbDatepicker></mat-datepicker>
                                    </div>
                                </div>
                                </div>

                            </div>
                        </form>

                        </div>
    
                        
                    </div>
                </mat-card-content>
            </mat-card>
    
    
             <!-- add new decument -->
             <div class="attachmentSidebar" style="overflow: auto;" *ngIf="showAddDocumentSection">
                <div class="sidebar-title" style="justify-content: space-between; padding:15px 15px; ;">
                  <div class="sidebar-title-text">Add New Document</div>
                  <div style="display: flex; justify-content: right; width: 50%; gap: 10px;">
                    <!-- <span style="color: #f99c30; font-size: 16px; font-weight: 700;">Total Suppliers : {{UniqueSupplier.length}}</span> -->
                    <!-- <span class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                    matTooltipPosition="below" (click)="expandSection(showSuggestedSupplierFullScreen)">
                  </span> -->
                    <span style="float: right;" class="pointer header-close-btn" matTooltipClass="mat-tooltip-custom" matTooltip="Close"
                      matTooltipPosition="below" (click)="toggleSidebar(false,'attachment')">
                      <mat-icon style="color: white;" >close</mat-icon>
                    </span>
                  </div>
                </div>
    
                <div class="sidebar-content" style="padding-top: 10px;">     
    
                    <mat-form-field class="full-width" color="accent">
                      <mat-label>Document Type</mat-label>
                      <mat-select [(ngModel)]="selectedAttachmentType">
                        <mat-option *ngFor="let item of headerAttachmentType" [value]="item.id"> {{item.documentTypeDescription}}</mat-option>
                      </mat-select>
                    </mat-form-field>
    
                <ngx-file-drop class="w100 file-drop-zone" dropZoneLabel="Drop files here" (onFileDrop)="onAttachmentChange($event)"
                (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" accept=".svg,.SVG,.png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF">
                <ng-template style="display: flex; flex-direction: row;" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <div class="drag-file">
                        <mat-icon>cloud_upload</mat-icon>
                        <p> Drag & drop the file here or </p>
                        <div class="" (click)="openFileSelector()">
                            <p style="color:#74c5b5">upload a file</p>
                        </div>
                        <p> *PDF, JPG or PNG  </p>
                    </div>
                </ng-template>
            </ngx-file-drop>
    
          
            <div *ngIf="firstFormGroup.get('quoteHeaderAttachments')?.value" style="display: flex; flex-direction: column;">
                <h3 style="padding-top: 20px;">Header Attachments</h3>
                <div class="file-name-box" *ngFor="let file of firstFormGroup.get('quoteHeaderAttachments')?.value" >{{ file.name }}
                    <div *ngIf="file.attachmentId && file.attachmentId!=null">
                    
                                
    
                         <button mat-icon-button matTooltipClass="mat-tooltip-custom" matTooltip="View" matTooltipPosition="below" (click)="downloadDocument(file.url)">
                             <mat-icon>download</mat-icon>
                          </button>
    
                          <button mat-icon-button matTooltipClass="mat-tooltip-custom" matTooltip="Delete" matTooltipPosition="below" (click)="removeAttachment(file)">
                            <mat-icon>delete</mat-icon>
                         </button>   
                    </div>
                    
                </div>
            </div>
            
           
              
                  
                
               
                    <div class="button-container">
                        <button type="button" class="save-button" (click)="saveAttachment()">
                            <mat-icon>save</mat-icon>
                        </button>
                        <button type="button" class="close-button" (click)="toggleSidebar(false,'attachment')">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </div>
                </div>
              </div>
    
        </div>
    </div>
    </div>
    
    
    
    
    
    
    
    <!-- Popup for confirmation -->
    <div class="namemodal" *ngIf="showDeclineConfirmationDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
                <p class="mb-6">Are you sure you want to decline this request for quotation?<br>Select a reason from the dropdown</p>
                <mat-form-field class="full-width" color="accent">
                    <mat-label>Decline reason</mat-label>
                    <mat-select [(ngModel)]="declineReason" >
                        
                        <mat-option value="Price is too high"> Price is too high</mat-option>
                        <mat-option value="Unable to meet specifications"> Unable to meet specifications</mat-option>
                        <mat-option value="Not available at this time"> Not available at this time</mat-option>
                        <mat-option value="No capacity to fulfill the order"> No capacity to fulfill the order</mat-option>
                        <mat-option value="Conflict of interest"> Conflict of interest</mat-option>
                        <mat-option value="Other"> Other</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="declineRfq()" [disabled]="declineReason == ''">Yes, Decline</button>
                    <button mat-stroked-button (click)="cancelDecline()">Cancel</button>
                </div>
            </div>
    
        </div>
    </div>
    
    
    
    
    
    <!-- Popup for confirmation -->
    <!-- <div class="namemodal" *ngIf="showModal">
        <div class="modalContent">
            <b>{{headOffice.name}}</b> is already set as the Main Branch. Are you sure you want to update the current branch to be the Main Branch? This will replace the existing Main Branch.
          <div class="modalButtons">
              <button class="connectButton" (click)="confirm()">Yes</button>
              <button class="cancelButton" (click)="closeModal()">Cancel</button>
          </div>
        </div>
        </div> -->
    
    <!-- Popup for confirmation -->
    <!-- <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
                <p class="mb-6">Are you sure you want to save this RFQ as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save()">Save as draft</button>
                    <button mat-stroked-button (click)="goToRfqCart()">Cancel</button>
                </div>
            </div>
    
        </div>
    </div> -->

    <!-- Popup for confirmation -->
    <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <!-- <h2 class="text-xl font-bold mb-2">You want to save this as draft?</h2> -->
                <p class="mb-6">You want to save this as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save(true)" style="margin-right: 5px;">YES</button>
                    <button mat-stroked-button (click)="cancel()" style="margin-left:5px">NO</button>
                </div>
            </div>
    
        </div>
    </div>



    <div
    class="blur"
    *ngIf="headerAttachmentSection"
    (click)="toggleHeaderAttachmentImage(false)"
></div>
<div class="carousel-container" *ngIf="headerAttachmentSection">
    <div class="carousel-close-button">
    <button class="image-close-button" (click)="toggleHeaderAttachmentImage(false)">
        <mat-icon>cancel</mat-icon>
    </button>
    </div>
    <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
        <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(headerAttachmentUrl)"
        >
            <pdf-viewer
            [src]="headerAttachmentUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="content"
            >
            </pdf-viewer>
        </div>
        <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(headerAttachmentUrl)"
        >
            <img
            [src]="headerAttachmentUrl"
            [alt]="'headerattachment image'"
            class="carousel-image"
            />
        </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
    </div>
</div>


<div
    class="blur"
    *ngIf="paymentTermsAndConditionsSection"
    (click)="togglePaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="paymentTermsAndConditionsSection">
    <div class="carousel-close-button">
    <button class="image-close-button" (click)="togglePaymentTermsAndConditionsAttachment(false)">
        <mat-icon style="font-size:20px">cancel</mat-icon>
    </button>
    </div>
    <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
        <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
        >
            <pdf-viewer
            [src]="paymentTermsAndConditionAttachmentUrl"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="content"
            >
            </pdf-viewer>
        </div>
        <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(paymentTermsAndConditionAttachmentUrl)"
        >
            <img
            [src]="paymentTermsAndConditionAttachmentUrl"
            [alt]="'headerattachment image'"
            class="carousel-image"
            />
        </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
    </div>
</div>



<div
    class="blur"
    *ngIf="buyerAttachmentsSection"
    (click)="toggleBuyerAttachments(false)"
></div>
<div class="carousel-container" *ngIf="buyerAttachmentsSection">
    <div class="carousel-close-button" style="display: flex; flex-direction: row; gap: 10px;">
    <button class="image-download-button" *ngIf="buyerAttachmentUrl.length>0"   (click)="downloadDocument(buyerAttachmentUrl[currentIndex])">
            <mat-icon style="font-size:20px">download</mat-icon>
    </button>

    <button class="image-close-button" (click)="toggleBuyerAttachments(false)">
        <mat-icon style="font-size:20px">cancel</mat-icon>
    </button>
    </div>
    <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button>

    <div class="carousel-image-container">
        <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(buyerAttachmentUrl[currentIndex])"
        >
            <pdf-viewer
            [src]="buyerAttachmentUrl[currentIndex]"
            [render-text]="false"
            [page]="1"
            [show-all]="true"
            [original-size]="false"
            class="content"
            >
            </pdf-viewer>
        </div>
        <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(buyerAttachmentUrl[currentIndex])"
        >
            <img
            [src]="buyerAttachmentUrl[currentIndex]"
            [alt]="'headerattachment image'"
            class="carousel-image"
            />
        </div>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button>
    </div>
</div>


<!-- Notification Overlay to Dim the Background -->
<div *ngIf="showNotification" class="notification-overlay"></div>

<!-- Custom Notification for Missing Fields -->
<div *ngIf="showNotification" 
     class="notification-popup" 
     [ngClass]="{'error-notification': notificationType === 'error', 'info-notification': notificationType === 'info', 'show': showNotification, 'hide': !showNotification}">
  <div class="notification-content">
    <div class="flex justify-center mb-4">
        <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
            <mat-icon class="text-orange-600"
                style="font-size: 75px;  height:100%; width:100%;">warning</mat-icon>
        </div>
    </div>
    <div class="notification-message" [innerHTML]="notificationMessage"></div> 
    <button (click)="dismissNotification()" class="btn-ok">OK</button>
  </div>
</div>